import axios from 'axios';

// Tiendas de plataforma (platform_stores). El baseURL de axios ya incluye
// /{tenant}/. `options` trae en una sola llamada los catálogos de los selects
// (plataformas, menús, sucursales, áreas, meseros) para que la pantalla no
// dependa de los permisos de menús ni del catálogo global de plataformas.
export default {
  list() {
    return axios.get('/platform/stores');
  },

  options() {
    return axios.get('/platform/stores/options');
  },

  get(id) {
    return axios.get(`/platform/store/${id}`);
  },

  create(data) {
    return axios.post('/platform/store', data);
  },

  update(id, data) {
    return axios.put(`/platform/store/${id}`, data);
  },

  remove(id) {
    return axios.delete(`/platform/store/${id}`);
  }
}
